import { useTranslate } from '@tolgee/react';
import { useCallback, useMemo } from 'react';

export const useGetMercadoReasonLabel = () => {
  const { t } = useTranslate();
  /**
   * 美客多原因映射关系
   * https://leyan.yuque.com/czpqnb/pd/amn09tm2m8f7somn#pGxQ
   */
  const reasonName2I18nMap: Record<string, string> = useMemo(
    () => ({
      proximity_deliveryman_not_found: t('找不到送货员'),
      better_price_available: t('aide.在别处找到更便宜的'),
      proximity_delivered_other: t('运输问题'),
      proximity_delivery_problem: t('运输问题'),
      proximity_shipping_problem: t('运输问题'),
      different_color_or_size: t('ViewDashboard.MERCADO.PDD9567'),
      different_color_or_size_acc: t('ViewDashboard.MERCADO.PDD9567'),
      different_color_or_size_fashion: t('ViewDashboard.MERCADO.PDD9567'),
      different_color_or_size_fashion_change: t('ViewDashboard.MERCADO.PDD9567'),
      sup_different_color_or_size: t('ViewDashboard.MERCADO.PDD9567'),
      sup_different_taste_or_size: t('ViewDashboard.MERCADO.PDD9567'),
      bought_by_mistake: t('由于失误而购买'),
      need_help_with_product: t('需要产品相关的帮助'),
      change_receiver_address: t('aide.修改收货地址'),
      cannot_coordinate_workshop: t('无法与工厂协调'),
      seller_unavailable: t('无法联系卖家'),
      buyer_unavailable: t('ViewDashboard.LAZADA.Customer unreachable'),
      repentant_buyer: t('ViewDashboard.MERCADO.PDD9502'),
      undelivered_repentant_buyer: t('ViewDashboard.MERCADO.PDD9502'),
      proximity_invalid_shipment_status: t('aide.未收到货物'),
      proximity_undelivered_other: t('aide.未收到货物'),
      tried_deliver_purchase_but_could_not: t('aide.未收到货物'),
      undelivered: t('aide.未收到货物'),
      undelivered_other: t('aide.未收到货物'),
      missing_invoice: t('未收到发票'),
      unauthorized_purchase: t('ViewDashboard.MERCADO.PDD9539'),
      delivered_out_of_time: t('未按约定日期交货'),
      delivered_out_of_time_carrier: t('未按约定日期交货'),
      delivery_date_modified: t('未按约定日期交货'),
      delivery_date_was_not_met: t('未按约定日期交货'),
      acc_incompatible_item_different: t('ViewDashboard.MERCADO.PDD9570'),
      acc_incompatible_item_repentant: t('ViewDashboard.MERCADO.PDD9570'),
      acc_item_not_useful_different: t('ViewDashboard.MERCADO.PDD9570'),
      item_not_useful_fashion_different: t('ViewDashboard.MERCADO.PDD9570'),
      item_not_useful_fashion_different_change: t('ViewDashboard.MERCADO.PDD9570'),
      item_not_useful_repentant: t('ViewDashboard.MERCADO.PDD9570'),
      sup_care_item_not_useful_different: t('ViewDashboard.MERCADO.PDD9570'),
      sup_care_item_not_useful_repentant: t('ViewDashboard.MERCADO.PDD9570'),
      sup_item_not_useful_different: t('ViewDashboard.MERCADO.PDD9570'),
      sup_item_not_useful_repentant: t('ViewDashboard.MERCADO.PDD9570'),
      size_not_useful_repentant: t('ViewDashboard.MERCADO.PDD9570'),
      defective_change_parent: t('收到商品有缺陷'),
      defective_item: t('收到商品有缺陷'),
      defective_item_change: t('收到商品有缺陷'),
      defective_item_other: t('收到商品有缺陷'),
      defective_item_other_parent: t('收到商品有缺陷'),
      sup_conservation_defective: t('收到商品有缺陷'),
      empty_box: t('aide.收到空包裹'),
      empty_box_parent: t('aide.收到空包裹'),
      different_than_published: t('aide.收到货物与介绍不符'),
      item_was_different: t('aide.收到货物与介绍不符'),
      not_match_size_guide_fashion: t('aide.收到货物与介绍不符'),
      colour_model_not_useful_repentant: t('aide.收到货物无法使用'),
      item_not_useful: t('aide.收到货物无法使用'),
      item_not_useful_different: t('aide.收到货物无法使用'),
      not_working_item: t('aide.收到货物无法使用'),
      not_working_item_parent: t('aide.收到货物无法使用'),
      product_stopped_working: t('aide.收到货物无法使用'),
      uncompats_item_with_vehicle_acc: t('aide.收到货物无法使用'),
      missing_item: t('aide.收到货物少件'),
      missing_item_change: t('aide.收到货物少件'),
      missing_item_change_parent: t('aide.收到货物少件'),
      missing_item_parent: t('aide.收到货物少件'),
      proximity_missing_item: t('aide.收到货物少件'),
      sup_missing_item: t('aide.收到货物少件'),
      sup_missing_item_parent: t('aide.收到货物少件'),
      incomplete_item: t('aide.收到货物少件'),
      incomplete_item_other: t('aide.收到货物少件'),
      incomplete_item_other_parent: t('aide.收到货物少件'),
      missing_accessories: t('ViewDashboard.MERCADO.PDD9565'),
      missing_accessories_change: t('ViewDashboard.MERCADO.PDD9565'),
      missing_accessories_change_parent: t('ViewDashboard.MERCADO.PDD9565'),
      missing_accessories_parent: t('ViewDashboard.MERCADO.PDD9565'),
      acc_broken_item: t('aide.收到货物破损'),
      acc_broken_item_parent: t('aide.收到货物破损'),
      broken_item: t('aide.收到货物破损'),
      broken_item_fashion: t('aide.收到货物破损'),
      broken_item_fashion_parent: t('aide.收到货物破损'),
      broken_item_parent: t('aide.收到货物破损'),
      damaged_product: t('aide.收到货物破损'),
      damaged_product_other: t('aide.收到货物破损'),
      sup_broken_item: t('aide.收到货物破损'),
      sup_broken_item_parent: t('aide.收到货物破损'),
      different_item: t('aide.收到货物错误'),
      different_item_other: t('aide.收到货物错误'),
      different_item_other_change: t('aide.收到货物错误'),
      proximity_different_item: t('aide.收到货物错误'),
      not_expected_quality_defective: t('ViewDashboard.MERCADO.PDD9515'),
      not_expected_quality_different: t('ViewDashboard.MERCADO.PDD9515'),
      not_expected_quality_repentant: t('ViewDashboard.MERCADO.PDD9515'),
      factory_problem: t('ViewDashboard.MERCADO.PDD9551'),
      vehicle_sold: t('商品已被卖掉了'),
      change_another_parent: t('aide.其他'),
      other: t('aide.其他'),
      other_reason: t('aide.其他'),
      proximity_other_problem: t('aide.其他'),
      confirmed_delivered_date_but_not_receive: t('卖家已送达，但未收到包裹'),
      delivered_but_not_receive: t('卖家已送达，但未收到包裹'),
      delivered_but_not_receive_package: t('卖家已送达，但未收到包裹'),
      invalid_shipment_status: t('卖家已送达，但未收到包裹'),
      seller_change_price: t('卖家修改价格'),
      buy_out_of_ml: t('卖家希望在Mercado外完成订单'),
      seller_without_documents: t('卖家没有相关文件'),
      out_of_stock: t('卖家没有库存'),
      seller_with_no_stock: t('卖家没有库存'),
      not_use_reservation: t('卖家没有保留库存'),
      seller_not_use_reservation: t('卖家没有保留库存'),
      respondent_unanswered: t('卖家不回复问题'),
      buyer_couldnot_pay: t('买家无法完成支付'),
      buyer_repentant: t('买家决定不再购买'),
      repentant_buyer_other: t('ViewDashboard.MERCADO.PDD9507'),
      sup_expired_item: t('ViewDashboard.LAZADA.Expired items'),
      fake_defective: t('ViewDashboard.MERCADO.PDD9537'),
      fake_different: t('ViewDashboard.MERCADO.PDD9537'),
      proximity_order_problem: t('订单问题'),
      estimated_delivery: t('超时未送达'),
      estimated_delivery_out_of_time: t('超时未送达'),
      proximity_undelivered_out_of_time: t('超时未送达'),
      partially_defective: t('ViewDashboard.MERCADO.PDD9559'),
      partially_defective_parent: t('ViewDashboard.MERCADO.PDD9559'),
      no_trust: t('不信任'),
      sup_conservation_defective_parent: t('包装损坏，商品有缺陷'),
      sup_damaged_package_conservation_defective: t('包装损坏，商品有缺陷'),
      damaged_package_incomplete_item_other: t('包装损坏，商品不完整'),
      damaged_package_missing_item: t('包装损坏，商品不完整'),
      damaged_package_missing_item_change: t('包装损坏，商品不完整'),
      sup_damaged_package_missing_item: t('包装损坏，商品不完整'),
      damaged_package_missing_accessories: t('ViewDashboard.MERCADO.PDD9566'),
      damaged_package_missing_accessories_change: t('ViewDashboard.MERCADO.PDD9566'),
      damaged_package_partially_defective: t('ViewDashboard.MERCADO.PDD9566'),
      damaged_package_empty_box: t('ViewDashboard.MERCADO.PDD9959'),
      damaged_package_not_working_item: t('ViewDashboard.MERCADO.PDD9950'),
      acc_damaged_package_broken_item: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_item: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_package: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_package_broken_item: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_package_broken_item_fashion: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_package_defective_item_change: t('ViewDashboard.MERCADO.PDD9554'),
      damaged_package_defective_item_other: t('ViewDashboard.MERCADO.PDD9554'),
      proximity_damaged_item: t('ViewDashboard.MERCADO.PDD9554'),
      sup_damaged_package_broken_item: t('ViewDashboard.MERCADO.PDD9554'),
    }),
    [t],
  );

  return useCallback(
    (reasonName?: string) => {
      return reasonName ? reasonName2I18nMap[reasonName] || reasonName : '-';
    },
    [reasonName2I18nMap],
  );
};
